export default theme => ({
  root: {
    margin: '0 0.2rem',
    boxShadow: theme.customShadows[1],
    minWidth: 'auto',
  },
});
